export default {
    // Header Section
    "discover_your": "Discover Your",
    "dasha_phal": "Dasha Phal",
    "planetary_periods_analysis": "Planetary Periods Analysis",
    "dasha_phal_description": "Your Vimshottari Mahadasha journey shows phases of strong career growth, wealth, recognition, and supportive relationships, especially during Venus, Sun, Moon, Mars, Rahu, and Saturn periods.",

    // Service Information
    "enter_birth_details": "Enter Your Birth Details",
    "complete_dasha_phal_analysis": "Complete Dasha Phal Analysis",
    "service_price": "Service Price",
    "comprehensive_dasha_analysis_note": "Comprehensive analysis of all major and minor planetary periods affecting your life",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "time_of_birth": "Time of Birth",
    "exact_time_critical_for_dasha": "Exact birth time is critical for accurate Dasha calculations",
    "place_of_birth": "Place of Birth",
    "place_of_birth_placeholder": "City, State, Country",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your analysis will be delivered in the selected language",

    // Features & Benefits
    "current_dasha_period_analysis": "Current Dasha Period Analysis",
    "planetary_influence_detailed": "Detailed Planetary Influence",
    "future_dasha_predictions": "Future Dasha Predictions",
    "career_and_finance_guidance": "Career & Finance Guidance",
    "remedial_measures": "Remedial Measures",
    "pdf_download": "PDF Download",

    "what_you_get": "What You Get",
    "current_mahadasha_antardasha": "Current Mahadasha & Antardasha",
    "planetary_effects_detailed": "Detailed Planetary Effects",
    "timing_of_events": "Timing of Important Events",
    "future_dasha_timeline": "Future Dasha Timeline",

    // Actions & Buttons
    "pay_and_generate_chart": "Pay & Generate Analysis",
    "processing_payment": "Processing Payment",
    "processing_request": "Processing Request",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "dasha_phal_analysis_processing": "Your Dasha Phal analysis request has been received and is being processed by our expert astrologers.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Delivery Time",
    "within_12_hours_delivery_note": "Your analysis will be delivered within 12 hours",
    "whatsapp_notification": "WhatsApp Notification",
    "whatsapp_delivery_note": "You'll receive updates on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Analysis will be sent to",

    // What You'll Receive
    "what_youll_receive": "What You'll Receive",
    "detailed_dasha_phal_report": "Detailed Dasha Phal Report (PDF)",
    "current_planetary_periods": "Current Planetary Periods Analysis",
    "future_dasha_predictions_timeline": "Future Dasha Predictions Timeline",
    "planetary_remedies_guidance": "Planetary Remedies & Guidance",
    "career_finance_predictions": "Career & Finance Predictions",

    // Visual Content
    "sample_dasha_phal": "Sample Dasha Phal Analysis",
    "sample_dasha_phal_description": "This is how your detailed Dasha Phal analysis will look",
    "major_planetary_periods": "Major Planetary Periods",

    // Planetary Periods
    "sun_dasha": "Sun Dasha",
    "moon_dasha": "Moon Dasha", 
    "mars_dasha": "Mars Dasha",
    "mercury_dasha": "Mercury Dasha",
    "jupiter_dasha": "Jupiter Dasha",
    "venus_dasha": "Venus Dasha",

    // Status & Processing
    "your_dasha_phal_analysis_status": "Your Dasha Phal Analysis Status",
    "processing_your_analysis": "Processing Your Analysis",
    "analysis_processing_message": "Our expert astrologers are carefully analyzing your birth chart and planetary periods.",
    "request_id": "Request ID",
    "status": "Status",
    "processing": "Processing",
    "pending": "Pending",
    "email_notification_sent": "Email notification sent",
    "whatsapp_update_coming": "WhatsApp update coming soon",
    "delivery_within_12_hours": "Delivery within 12 hours",

    // Support & Contact
    "contact_support": "Contact Support",
    "need_help": "Need help?",
    "contact_us_at": "Contact us at",

    // Error Messages
    "please_fill_all_required_fields": "Please fill all required fields",
    "payment_failed": "Payment failed. Please try again.",
    "processing_failed": "Processing failed. Please contact support.",

    // Form Validation Messages
    "name_required": "Name is required",
    "email_required": "Email is required",
    "phone_required": "Phone number is required",
    "date_required": "Date of birth is required",
    "time_required": "Time of birth is required",
    "place_required": "Place of birth is required"
} 